module.exports = __webpack_public_path__ + "img/xing.23a1645c.svg";